import {
	EuiFlexGroup,
	EuiFlexItem,
} from '@equipmentshare/ds2'

import GroupUsersTable from '../GroupUsersTable'
import GroupPoliciesTable from '../GroupPoliciesTable'

import { useGroupQuery, Group, User, ResourcePolicy } from '../../../../../../graphql'

import { useDispatchSetSelectedModal } from 'contexts/modal-context/modal-context'
import { getAddPolicyModal, getAddUsersModal, getRemovePolicyModal, getRemoveUserModal } from '../actionModals'
import { heapEvent } from '@equipmentshare/heaper'


export type GroupItemProps = {
	groupId: number,
}

export default function GroupItem( { groupId }: GroupItemProps ) {
	const setSelectedModal = useDispatchSetSelectedModal()
	const { data, loading, refetch } = useGroupQuery( { variables: { groupId } } )
	const group = data?.group as Group

	const onAddUsersClick = () => {
		heapEvent( 'Inventory - Permission Groups - Click - Add User', {} )
		if ( group ) {
			setSelectedModal( getAddUsersModal( group, refetch ) )
		}
	}

	const onAddPolicyClick = () => {
		heapEvent( 'Inventory - Permission Groups - Click - Add Policy', {} )
		if ( group ) {
			setSelectedModal( getAddPolicyModal( group, refetch ) )
		}
	}

	const onRemoveUserClick = ( user: User ) => {
		heapEvent( 'Inventory - Permission Groups - Click - Remove User', {} )
		if ( group ) {
			setSelectedModal( getRemoveUserModal( user, group, refetch ) )
		}
	}
	const onRemovePolicyClick = ( policy: ResourcePolicy ) => {
		heapEvent( 'Inventory - Permission Groups - Click - Remove Policy', {} )
		if ( group ) {
			setSelectedModal( getRemovePolicyModal( policy, group, refetch ) )
		}
	}

	return (
		<EuiFlexGroup>
			<EuiFlexItem>
				<GroupUsersTable
					isLoading={loading}
					users={group?.users ?? []}
					onAddUserClick={onAddUsersClick}
					confirmDeleteUser={onRemoveUserClick}
				/>
			</EuiFlexItem>
			<EuiFlexItem>
				<GroupPoliciesTable
					isLoading={loading}
					policies={group?.policies ?? []}
					onAddPolicyClick={onAddPolicyClick}
					onRemovePolicyClick={onRemovePolicyClick}
				/>
			</EuiFlexItem>
		</EuiFlexGroup>
	)
}
